/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { currencyList } from "~/constants/currencyList";

export const displayCurrencySymbol = (currency: string) =>
  currencyList.find((cur) => cur.code === currency)?.symbol;
